module.exports = __webpack_public_path__ + "static/media/festivals_i_mostres.8c8a9c43.jpg";